import { ArrowDown, ArrowUp, FileText, X } from "lucide-react";

const fmtSize = (b) => (b > 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1).replace(".", ",")} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

const IconBtn = ({ testId, title, onClick, disabled, children, danger }) => (
  <button type="button" data-testid={testId} title={title} onClick={onClick} disabled={disabled}
    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-slate-400 transition-colors disabled:opacity-30 ${danger ? "hover:bg-red-50 hover:text-red-600" : "hover:bg-slate-100 hover:text-slate-800"}`}>
    {children}
  </button>
);

export const MergeList = ({ files, onMove, onRemove }) => (
  <ol data-testid="merge-list" className="divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white">
    {files.map((f, i) => (
      <li key={`${f.name}-${f.size}`} data-testid={`merge-item-${i}`} className="flex items-center gap-3 px-4 py-2.5">
        <span className="w-6 shrink-0 text-center font-mono text-xs text-slate-400">{i + 1}</span>
        <FileText className="h-4 w-4 shrink-0 text-emerald-700" />
        <span data-testid={`merge-item-name-${i}`} className="min-w-0 flex-1 truncate text-sm text-slate-800">{f.name}</span>
        <span className="hidden shrink-0 font-mono text-xs text-slate-400 sm:inline">{fmtSize(f.size)}</span>
        <IconBtn testId={`merge-up-${i}`} title="Sposta su" onClick={() => onMove(i, -1)} disabled={i === 0}><ArrowUp className="h-4 w-4" /></IconBtn>
        <IconBtn testId={`merge-down-${i}`} title="Sposta giù" onClick={() => onMove(i, 1)} disabled={i === files.length - 1}><ArrowDown className="h-4 w-4" /></IconBtn>
        <IconBtn testId={`merge-remove-${i}`} title="Togli" onClick={() => onRemove(i)} danger><X className="h-4 w-4" /></IconBtn>
      </li>
    ))}
  </ol>
);
